import classes from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { Box, Button, Flex, Group, Image, Text } from '@mantine/core';
export type BuyCryptoProps = {
  handleClick: () => void;
};
export const BuyCrypto: React.FC<BuyCryptoProps> = ({
  handleClick
}) => {
  const {
    i18n
  } = useLingui();
  return <Flex justify={{
    base: 'center',
    sm: 'end'
  }} mt={{
    base: 0,
    lg: 36
  }}>
      <Box>
        <Text fz={13} fw={700} tt="uppercase" c="var(--text-dark)">
          {i18n._('DON’t HAVE ANY TETHER?')}
        </Text>
        <Button fz={13} h={46} fw={700} mt={8} fullWidth classNames={classes} onClick={handleClick} leftSection={<Icons className="icon-pr-line-card" fontSize={24} />}>
          {i18n._('BUY CRYPTO')}
        </Button>
        <Group mt={14} justify="space-between">
          <Image src="/assets/wallet/visa.png" w={83} h={27} alt="visa" />
          <Image src="/assets/wallet/mastercard.png" w={56} h={56} alt="card" />
        </Group>
      </Box>
    </Flex>;
};